import { render, staticRenderFns } from "./subject-count.vue?vue&type=template&id=b922d4aa&scoped=true"
import script from "./subject-count.vue?vue&type=script&lang=js"
export * from "./subject-count.vue?vue&type=script&lang=js"
import style0 from "./subject-count.vue?vue&type=style&index=0&id=b922d4aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b922d4aa",
  null
  
)

export default component.exports